import axios, { AxiosInstance } from "axios";
import { useContext, useRef } from "react";

import { AuthContext } from "context/Auth";

let _token = "";
export const useClient = () => {
  const { refreshSession } = useContext(AuthContext);
  const refreshSessionRef = useRef(refreshSession);
  refreshSessionRef.current = refreshSession;
  const clientRef = useRef<AxiosInstance>();

  if (!clientRef.current) {
    const client = axios.create({
      baseURL: process.env.REACT_APP_API_HOST,
      headers: {
        "X-Certain-Client": `web/${process.env.REACT_APP_VERSION}`,
      },
    });

    // Cached query functions can use this client after its hook owner unmounts.
    client.interceptors.request.use((request) => {
      request.headers["Authorization"] = `Bearer ${_token}`;

      return request;
    });

    client.interceptors.response.use(
      (response) => response,
      (error) => {
        const statusCode = error.response ? error.response.status : null;

        if (statusCode === 403 || statusCode === 500) {
          // Refresh does not retry this request, especially if it was a write.
          Promise.resolve()
            .then(() => refreshSessionRef.current())
            .catch(() => {});
        }

        throw error;
      },
    );
    clientRef.current = client;
  }

  return clientRef.current;
};

const client = axios.create({
  baseURL: process.env.REACT_APP_API_HOST,
});

export const setClientToken = (token: string) => {
  _token = token;

  client.defaults.headers["Authorization"] = `Bearer ${token}`;
};

export default client;
